(function () {
    'use strict';

    angular
        .module('app')
        .controller('ProfileController', ProfileController);

    // Controller
    ProfileController.$inject = [
        '$rootScope',
        '$scope',
        'LANGS',
        '$translate',
        '$location',
        '$routeParams',
        '$uibModal',
        'UserService',
        'NotifyService',
        'BusinessService',
        'blockUI'
    ];

    function ProfileController(
        $rootScope,
        $scope,
        LANGS,
        $translate,
        $location,
        $routeParams,
        $uibModal,
        UserService,
        NotifyService,
        BusinessService,
        blockUI
    ) {

        $scope.user = angular.copy($rootScope.USER);
        // $scope.modelState = ObjectState();
        // $scope.modelState.loaded();
        $scope.currentPath = 'settings';
        $scope.inlineMessage = '';

        $scope.currentTab = 'general';

        $scope.model = {};
        $scope.legal_info = {};
        $scope.staff = {
            password: '',
            // Avatar image
            srcImage: '',
            croppedImage: '',
            newImage: false
        };

        $scope.isPhoneValid = isPhoneValid;
        $scope.isEmailValid = isEmailValid;

        $scope.LANGS = LANGS;
        $scope.isPinCode = false;
        $scope.isPinCodePhone = false;

        $scope.legal_ownership_types = {
            'natural-person': 'Private person',
            'legal-entity': 'Company'
        }

        $scope.isFormWasChanged = false;

        var block_personal = blockUI.instances.get('personal');
        var block_notifications = blockUI.instances.get('notifications');

        initController();

        // =============================================================================================================
        // MAIN PART
        // =============================================================================================================


        function initController() {
            // $scope.modelState.loading();

            // TODO Case routing by tab
            showPersonalTab();

            if ($routeParams['tab']) {
                $scope.currentTab = $routeParams['tab'];
                onSwitchTab($routeParams['tab']);
            }
        }

        /**
         * Main tabs changes. Need for initialize data specifics by tab
         */
        $scope.onChangeTab = function (tab) {
            console.info('TAB', tab);

            var form_user, form_avatar, form_email, form_password, form_phone, form_notifications;
            if (angular.element('#form_user').scope())
                form_user = angular.element('#form_user').scope().form_user;
            if (angular.element('#form_avatar').scope())
                form_avatar = angular.element('#form_avatar').scope().form_avatar;
            if (angular.element('#form_password').scope())
                form_password = angular.element('#form_password').scope().form_password;
            if (angular.element('#form_phone').scope())
                form_phone = angular.element('#form_phone').scope().form_phone;
            if (angular.element('#form_email').scope())
                form_email = angular.element('#form_email').scope().form_email;
            if (angular.element('#form_notifications').scope())
                form_notifications = angular.element('#form_notifications').scope().form_notifications;

            $scope.isFormWasChanged = form_user.$dirty
                || form_avatar.$dirty
                || form_email.$dirty
                || form_phone.$dirty
                || form_password.$dirty
                || form_notifications.$dirty;

            if ($scope.isFormWasChanged) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    keyboard: true,
                    size: 'sm',
                    templateUrl: 'app/templates/modal.confirmation.html',
                    controllerAs: 'popup',
                    controller: function ($uibModalInstance) {
                        var popup = this;

                        popup.type = 'profile';

                        popup.onSaveClick = function (exit) {
                            if (form_user.$dirty && form_user.$valid) {
                                $scope.changeProfile();
                                form_user.$dirty = false;
                            }
                            if (form_email.$dirty && form_email.$valid) {
                                $scope.changeEmail();
                                form_email.$dirty = false;
                            }
                            if (form_password.$dirty && form_password.$valid) {
                                $scope.changePassword();
                                form_password.$dirty = false;
                            }
                            if (form_phone.$dirty && form_phone.$valid) {
                                $scope.changePhoneNumber();
                                form_phone.$dirty = false;
                            }
                            if (form_avatar.$dirty) {
                                $scope.changeAvatar();
                                form_avatar.$dirty = false;
                            }
                            if (form_notifications.$dirty) {
                                $scope.changeNotifications();
                                form_notifications.$dirty = false;
                            }

                            $scope.currentTab = tab;
                            $location.url($location.$$path + '?tab=' + tab);
                            onSwitchTab(tab);
                            $uibModalInstance.close();
                        };

                        popup.onCancelClick = function (exit) {
                            $scope.currentTab = tab;
                            $location.url($location.$$path + '?tab=' + tab);
                            onSwitchTab(tab);
                            $uibModalInstance.close();
                        };
                    }
                });
            } else {
                $scope.currentTab = tab;
                $location.url($location.$$path + '?tab=' + tab);
            }

        };

        function onSwitchTab(tab) {
            switch (tab) {
                case 'notifications':
                    showNotificationsTab();
                    break;
            }
        }

        // =============================================================================================================
        // PERSONAL SETTINGS TAB
        // =============================================================================================================

        function showPersonalTab() {
            block_personal.start();
            UserService.Profile(function (success, user) {
                if (success) {
                    $scope.user = angular.copy($rootScope.USER);
                    prepareUser();
                }
                block_personal.stop();
            });
        }

        function prepareUser() {
            $scope.staff.email_confirmed = false;
            if ($scope.user.emails) {
                $scope.user.emails.forEach(function (item) {
                    $scope.staff.email_confirmed = $scope.staff.email_confirmed || (item.value == $scope.user.login && item.confirm == 1);
                });
            }
        }

        $scope.changeProfile = function () {
            block_personal.start();
            if (!$scope.user.avatar)
                delete $scope.user.avatar;

            var post_data = angular.copy($scope.user);

            UserService.ChangeProfile(post_data, function (success, user) {
                if (success) {
                    $scope.user = user;
                    prepareUser();
                    angular.element('#form_user').scope().form_user.$dirty = false;
                    NotifyService.Success('', false);
                }
                block_personal.stop();
            });
        };

        /**
         * Raised when user select local file
         * @param evt
         */
        $scope.handleFileSelect = function (evt) {
            var file = evt.currentTarget.files[0],
                reader = new FileReader();

            var imageType = file.type,
                isPng = imageType === 'image/png';

            reader.onload = function (e) {
                var img = new Image();

                img.onload = function () {
                    var canvas = document.getElementById('file-canvas'),
                        ctx = canvas.getContext('2d'),
                        width = img.width,
                        height = img.height,
                        maxAllowedSize = 2 * 1024 * 1024;

                    canvas.width = width;
                    canvas.height = height;
                    ctx.clearRect(0, 0, width, height);
                    ctx.drawImage(img, 0, 0, width, height);

                    var resizedImageDataUrl;

                    if (isPng) {
                        resizedImageDataUrl = canvas.toDataURL('image/png');
                    } else {
                        resizedImageDataUrl = canvas.toDataURL('image/jpeg', 1);
                    }

                    if (resizedImageDataUrl.length > maxAllowedSize) {
                        var scale = 0.95,
                            quality = 1;

                        do {
                            width = Math.round(img.width * scale);
                            height = Math.round(img.height * scale);

                            canvas.width = width;
                            canvas.height = height;
                            ctx.clearRect(0, 0, width, height);
                            ctx.drawImage(img, 0, 0, width, height);

                            if (isPng) {
                                resizedImageDataUrl = canvas.toDataURL('image/png');
                            } else {
                                quality = Math.max(quality - 0.05, 0.1);
                                resizedImageDataUrl = canvas.toDataURL('image/jpeg', quality);
                            }

                            scale -= 0.05;
                        } while (
                            resizedImageDataUrl.length > maxAllowedSize &&
                            width > 50 && height > 50
                            );
                    }

                    $scope.$apply(function () {
                        $scope.staff.newImage = true;
                        $scope.staff.srcImage = resizedImageDataUrl;
                    });
                };
                img.src = e.target.result;
            };

            reader.readAsDataURL(file);

        };
        //angular.element('#fileAvatar').on('change', $scope.handleFileSelect);

        $scope.initImgCrop = function () {
            var file = angular.element(document.getElementById("fileAvatar"));
            file.on('change', $scope.handleFileSelect);
        }

        /**
         * User click button 'Submit avatar'
         */
        $scope.changeAvatar = function () {
            // console.info('image', $scope.croppedImage);   
            UserService.uploadAvatar($scope.staff.croppedImage, function (success, user) {
                if (success) {
                    // $timeout(function() {
                    //
                    // }, 0);
                    $scope.staff.newImage = false;
                    $scope.staff.srcImage = '';
                    $scope.staff.croppedImage = '';
                    $scope.user = angular.copy($rootScope.USER);
                    $scope.user = user;
                    prepareUser();

                    angular.element('#form_avatar').scope().form_avatar.$dirty = false;
                    NotifyService.Success('', false);

                    //
                }
            });
        };

        /**
         * Submit change email form
         */
        $scope.changeEmail = function () {

            var form_email = angular.element('#form_email').scope().form_email
            if ($scope.user.login !== '' && !form_email.$invalid) {

                block_personal.start();
                var post_data = {
                    value: $scope.user.login,
                    pin: form_email.pincode ? form_email.pincode.$viewValue : ''
                }

                UserService.RequestEmailChangePre(post_data, function (success, response) {
                    if (success) {

                        $scope.isPinCode = response.code !== undefined;

                    } else {
                        NotifyService.Error(response.message, false)
                        $scope.isPinCode = false;
                    }
                    block_personal.stop();

                });
            }
        }
        /**
         * Submit change phone form
         */
        $scope.changePhoneNumber = function () {
            var form_phone = angular.element('#form_phone').scope().form_phone
            if ($scope.user.phone !== '' && !form_phone.$invalid) {

                block_personal.start();
                var post_data = {
                    value: $scope.user.phone,
                    pin: form_phone.pincodePhone ? form_phone.pincodePhone.$viewValue : ''
                }
                console.log("post_data", post_data)
                UserService.RequestPhoneChangePre(post_data, function (success, response) {
                    if (success) {

                        $scope.isPinCodePhone = response.code !== undefined;

                    } else {
                        NotifyService.Error(response.message, false)
                        $scope.isPinCodePhone = false;
                    }
                    block_personal.stop();

                });
            }
        }
        /**
         * Submit change password form
         */
        $scope.changePassword = function () {
            block_personal.start();
            if ($scope.staff.password) {
                UserService.ChangePassword({password: $scope.staff.password}, function (success, response) {
                    if (success) {
                        angular.element('#form_password').scope().form_password.$dirty = false;
                        NotifyService.Success('', false);
                        $scope.staff.password = '';
                    } else {
                        var isInlineMessage = response.code == 1 || response.code == 2 || response.code == 4 || response.code == 5;
                        if (isInlineMessage) {
                            $scope.inlineMessage = response.message;
                        }
                    }
                    block_personal.stop();
                });
            } else {
                angular.element('#form_password').scope().form_password.$dirty = true;
                block_personal.stop();
            }
        };

        $scope.onChangeLanguage = function () {
            $translate.use($scope.user.language);
        };

        // $scope.onConfirmEmail = function (m) {
        //     console.info('Confirm email', m);
        //     UserService.RequestConfirmEmail(m.value, function (success, response) { });
        // };


        // =============================================================================================================
        // NOTIFICATIONS TAB
        // =============================================================================================================

        function showNotificationsTab() {
            block_notifications.start();
            UserService.NotificationsSettings(function (success, data) {
                if (success) {
                    $scope.notification_settings = data;
                }
                block_notifications.stop();
            })
        }

        $scope.changeNotifications = function (form) {
            block_notifications.start();
            UserService.NotificationsSettingsEdit($scope.notification_settings, function (success, data) {
                if (success) {
                    $scope.notification_settings = data;
                    angular.element('#form_notifications').scope().form_notifications.$dirty = false;
                    NotifyService.Success('', false);
                }
                block_notifications.stop();
            });
        };

    }
})();
